import {NavBar} from "./components/NavBar/NavBar.jsx"
import { Router } from "./Router/Router.jsx"
function App() {
  return (
    <div>
    <NavBar/>
    <Router/>
    </div>
  
  );
}

export default App;
